var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 112.169-223.421-107.473-223.421 107.473 223.421 107.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.579 254.279-159.757-76.847-63.664 30.624 223.421 107.473 223.421-107.473-63.664-30.624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.788 429.8c-4.848 18.186-13.133 34.984-24.125 49.644l57.917 27.86 223.42-107.473-63.664-30.625-159.757 76.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.292 329.345c9.213 19.077 14.389 40.453 14.389 63.019 0 1.709-.04 3.409-.099 5.104l28.997 13.948 223.421-107.472-63.664-30.624-159.757 76.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.233 278.131c-62.989 0-114.233 51.245-114.233 114.233s51.244 114.232 114.233 114.232 114.233-51.244 114.233-114.232-51.244-114.233-114.233-114.233zm63.796 129.84h-48.189v48.188h-31.214v-48.188h-48.188v-31.215h48.188v-48.188h31.215v48.188h48.189v31.215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerAdd);
export default __webpack_public_path__ + "static/media/layer-add.62724f08bd1e05c4d66a39f209de0d2e.svg";
export { ForwardRef as ReactComponent };